import d3 from 'd3';

export default function(rowEnter, options, isDistribution = false) {
  const item = rowEnter.selectAll('.legend-item')
    .data((d) => d);

  const itemEnter = item.enter()
    .append('g')
    .classed('legend-item', true)
    .attr('transform', (d, i) => {
      const x = i % 4 * options.columnWidth;
      return `translate(${x},0)`;
    });

  const itemText = itemEnter.append('text')
    .classed({
      'legend-text': true,
      'legend-text-distribution': isDistribution,
    })
    .attr('fill', '#000')
    .attr(
      'transform',
      `translate(${options.textPadding.left}, ${options.textPadding.top})`
    )
    .style(options.font);

  itemEnter.append('g')
    .classed({
      'legend-symbol': true,
      'legend-symbol-distribution': isDistribution,
    })
    .attr('height', 30)
    .attr('width', 30)
    .style({
      'stroke-width': 0,
    });

  const itemSymbol = itemEnter.select('.legend-symbol');

  if (isDistribution) {
    itemText.text((d) => d.characteristic);

    itemSymbol.append('path')
      .classed('distributions-symbol', true)
      .attr('transform', 'translate(10, 11)')
      .attr(
        'd',
        d3.svg
          .symbol()
          .type((d) => d.shape)
          .size(15)
      )
      .attr('fill', '#fff')
      .attr('stroke', '#000')
      .style({
        'stroke-width': 2,
      });
  } else {
    itemText.text((d) => d.state || d.name);

    itemSymbol.append('rect')
      .classed('legend-symbol-bg', true)
      .attr('height', 20)
      .attr('width', 20)
      .attr('transform', 'translate(3,3)')
      .style({
        'stroke-width': 0,
        'fill': '#e7e7e7',
      });

    itemSymbol.append('rect')
      .classed('legend-symbol', true)
      .attr('height', 20)
      .attr('width', 20)
      .attr('transform', 'translate(0,0)')
      .style({
        'fill': (d) => d.color,
        'stroke-width': 0,
      });
  }

  item.exit();
}



// WEBPACK FOOTER //
// ../~/eslint-loader!./js/util/d3.legend/items.js